function animateNumberReveal(selector) {
  const items = document.querySelectorAll(selector);

  if (items.length === 0) return;

  function getRandomCharacter() {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
    return chars.charAt(Math.floor(Math.random() * chars.length));
  }

  function animateNumbers(item) {
    const targetNumber = item.innerText;
    const fragment = document.createDocumentFragment();
    const numberSpans = [];

    // Spaces stay plain text so the value can still wrap where it normally would.
    targetNumber.split("").forEach((char) => {
      if (char === " ") {
        fragment.appendChild(document.createTextNode(char));
        return;
      }
      const span = document.createElement("span");
      span.textContent = char;
      fragment.appendChild(span);
      numberSpans.push({ span, char });
    });

    item.innerHTML = "";
    item.appendChild(fragment);

    // Lock each character to its final width so wider random glyphs can't
    // reflow the line (and shift the layout) while scrambling.
    const widths = numberSpans.map(({ span }) => span.getBoundingClientRect().width);
    numberSpans.forEach(({ span }, index) => {
      span.style.display = "inline-block";
      span.style.width = `${widths[index]}px`;
      span.style.textAlign = "center";
    });

    let remaining = numberSpans.length;
    numberSpans.forEach(({ span, char }, index) => {
      const randomInterval = setInterval(() => {
        span.textContent = getRandomCharacter();
      }, 50);

      setTimeout(
        () => {
          clearInterval(randomInterval);
          span.textContent = char;
          remaining -= 1;
          // Restore plain text so the locked widths don't outlive the animation.
          if (remaining === 0) item.textContent = targetNumber;
        },
        700 + index * 200,
      );
    });
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateNumbers(entry.target);
        observer.unobserve(entry.target);
      }
    });
  });

  items.forEach((item) => {
    observer.observe(item);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  animateNumberReveal(
    ".stat-cards--agencies .jsCounter, .js-contact-stats--counter",
  );
});
